import { PageTitle } from "@/lib/mui/PageTitle";
import { ContactButton } from "@/lib/nemmp/base";
import { getPrivacyPolicyHtml } from "@/modules/static/getPrivacyPolicyHtml";
import { getWebsiteLayout } from "@/modules/navigation/website-layout/WebsiteLayout";
import { css } from "@emotion/css";
import Head from "next/head";
import React from "react";
import { appConfig } from "../config/app-config";
import { NextPageWithLayout } from "./_app";

const Page: NextPageWithLayout<{ html: string }> = ({ html }) => {
  return (
    <>
      <Head>
        <title>Privacy Policy – {appConfig.name}</title>
      </Head>

      <PageLayout>
        <PageTitle>Privacy Policy</PageTitle>

        <article>
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </article>
        <section
          className={css`
            margin-top: 1em;
          `}
        >
          <ContactButton variant="contained" />
        </section>
      </PageLayout>
    </>
  );
};

const PageLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div style={{ maxWidth: "50em", margin: "10vh auto", padding: "1em" }}>
      {children}
    </div>
  );
};

export async function getServerSideProps() {
  return {
    props: { html: await getPrivacyPolicyHtml() },
  };
}

Page.getLayout = getWebsiteLayout;

export default Page;
